<template>
  <jczh-upload
    ref="upload"
    v-bind="propsValue"
    :file-id-before.sync="fileIdBeforeTemp"
    :group-id-before.sync="groupIdBeforeTemp"
    @change="fileList => $emit('change', fileList)"
  >
    <slot slot="btn" name="btn"></slot>
    <slot slot="tip" name="tip"></slot>
  </jczh-upload>
</template>

<script>
import { mapState } from 'vuex'
import {
  signatureApi,
  getUploadPolicy,
  uploadFileApi,
  getGroupApi,
  getFileListByGroupIdApi,
  getFileListByFileIdsApi,
  getFileUrlByFileIdApi,
  getFilePreviewUrlApi,
  deleteFileApi
} from '@/api/up-file.js'

export default {
  name: 'TestUpload',

  props: {
    propsData: {
      type: Object,
      default: () => {}
    },

    fileIdBefore: {
      type: [String, Number, Array],
      default: ''
    },

    groupIdBefore: {
      type: [String, Number],
      default: ''
    }
  },

  computed: {
    ...mapState('user', ['employeeId']),

    fileIdBeforeTemp: {
      get() {
        return this.fileIdBefore || this.propsData.fileIdBefore
      },
      set(val) {
        this.$emit('update:fileIdBefore', val)
      }
    },

    groupIdBeforeTemp: {
      get() {
        return this.groupIdBefore || this.propsData.groupIdBefore
      },
      set(val) {
        this.$emit('update:groupIdBefore', val)
      }
    },

    propsValue() {
      return Object.assign(
        {},
        {
          platform: process.env.VUE_APP_PLATFORM_CONSTANT,
          employeeId: this.employeeId,
          signatureApi: this.signatureApiTemp,
          uploadFileApi: uploadFileApi,
          deleteFileApi: deleteFileApi,
          getGroupIdApi: this.getGroupId,
          getFileListByGroupIdApi: getFileListByGroupIdApi,
          getFileUrlByFileIdApi: getFileUrlByFileIdApi,
          getFileInfoByFileIdApi: getFileListByFileIdsApi,
          getFileWPSPreviewMesApi: getFilePreviewUrlApi
        },
        this.propsData
      )
    }
  },

  methods: {
    uploadComplete() {
      return this.$refs.upload.uploadComplete()
    },

    // 根据传入的uploadMode确定使用的获取凭证函数
    signatureApiTemp(platform, params) {
      if (this.propsData.uploadMode === 'resource') {
        return new Promise((resolve, reject) => {
          getUploadPolicy(params)
            .then(res => {
              resolve(res)
            })
            .catch(err => {
              this.$message.error(err.message)
              reject()
            })
        })
      } else {
        return new Promise((resolve, reject) => {
          signatureApi(platform, params)
            .then(res => {
              resolve(res)
            })
            .catch(err => {
              this.$message.error(err.message)
              reject()
            })
        })
      }
    },
    getGroupId(platform, params) {
      return new Promise((resolve, reject) => {
        getGroupApi(platform, params)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            this.$message.error(err.message)
            reject()
          })
      })
    }
  }
}
</script>
